import * as React from 'react';
import { useUpdateReject } from '@/hooks/api/useRejects';
import { useNotification } from '@/contexts/NotificationContext';
import RejectFormModal from '@/components/reject/RejectFormModal';
import { Typography, Box, IconButton } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import {
  MaterialReactTable,
  MRT_ActionMenuItem,
  type MRT_ColumnDef,
} from 'material-react-table';
import { IReject } from '@/stack-shared/interfaces/model/reject.interface';
import { formatDateHourMinuteSecond } from '@/stack-shared/utils/gen-utils';

interface RejectTableProps {
  type: 'trk' | 'atm',
  assetId: number
  rejects: IReject[]
}

function RejectTable({
  type,
  assetId,
  rejects
}: RejectTableProps) {

  const [reportRejectVisible, setReportRejectVisible] = React.useState(false);
  const [initalValues, setInitialValues] = React.useState({});
  const [rejectId, setRejectId] = React.useState(0);
  const updateRejectMutation = useUpdateReject();
  const { showSuccess, showError } = useNotification();

  const submitReject = (values: any) => {
    console.log('Reject submitted', values);
    updateRejectMutation.mutate({ ...values, type, assetId, id: rejectId }, {
      onSuccess: () => {
        setReportRejectVisible(false);
        showSuccess("Reject Updated!");
      },
      onError: (error: any) => {
        showError(error.message || "Failed to update reject");
      },
    });
  }

  const goaRejectColumns = [
    {
      accessorKey: 'rejectDate',
      header: 'Reject Date',
      Cell: ({ row }: any) => {
        return formatDateHourMinuteSecond(row?.original?.rejectDate);
      },
    },
    {
      accessorKey: 'reportedTotalCash',
      header: 'Reported Total Cash ($)',
    },
    {
      accessorKey: 'actualCashCount',
      header: 'Actual Cash Count ($)',
    },
    {
      accessorKey: 'difference',
      header: 'Difference ($)',
    },
    {
      accessorKey: 'comments',
      header: 'Comments',
    },
  ];

  return (
    <>
      <MaterialReactTable
        renderTopToolbarCustomActions={() => (
          <Typography variant="h6" >
            {type.toUpperCase()} Rejects
          </Typography>
        )}
        columns={goaRejectColumns as any} data={rejects} initialState={{ density: 'compact' }}
        enableRowActions
        positionActionsColumn="last"
        renderRowActions={({ row }) => (
          <Box>
            <IconButton onClick={() => {
              setInitialValues(row.original);
              setRejectId(Number(row.original.id))
              setReportRejectVisible(true);
            }}>
              <Edit />
            </IconButton>
          </Box>
        )}
      />

      <RejectFormModal
        visible={reportRejectVisible}
        onDismiss={() => setReportRejectVisible(false)}
        onSubmit={submitReject}
        initialValues={initalValues}
        title={`Update ${type.toUpperCase()} Reject`}
        trks={[]}
        atms={[]}
        assetId={assetId}
      />
    </>
  );
}

export default RejectTable;
